<template>
    <div>
        <!-- Loading Indicator -->
        <div v-if="loading" class="text-center my-3">
            <b-spinner label="Loading..."></b-spinner>
        </div>

        <!-- Playlists Cards -->
        <div v-else>
            <div class="row">
                <div
                    class="col-md-4 mb-4"
                    v-for="playlist in playlists"
                    :key="playlist.id"
                >
                    <playlist-component
                        :playlist="playlist"
                        @playlist-deleted="removePlaylist"
                    ></playlist-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            playlists: [],
            loading: false,
        };
    },
    mounted() {
        this.fetchPlaylists();
    },
    methods: {
        async fetchPlaylists() {
            this.loading = true;
            try {
                const response = await axios.get(
                    '/api/me/playlists?type=quickclasses'
                );
                this.playlists = response.data;
            } catch (error) {
                console.error('Error fetching playlists:', error);
                alert('Failed to load playlists.');
            } finally {
                this.loading = false;
            }
        },
        removePlaylist(playlistId) {
            // Remove the playlist with the given ID from the playlists array
            this.playlists = this.playlists.filter(
                (playlist) => playlist.id !== playlistId
            );
        },
    },
};
</script>
